<script setup lang="ts">
/** Attendance List.docx — AFS(PRS041) / UFS(PRS026). 회원 유형별 MEMBERS 표(복수는 회원 목록 편집). */
import CddVarField from '../../../../preset/components/final-dividends/cdd/CddVarField.vue';
import '../../../../preset/components/final-dividends/docs/agmDoc.css';
import AgmDocHead from '../AgmDocHead.vue';
import AgmMeetingTable from '../AgmMeetingTable.vue';
import AgmRowsEditor from '../AgmRowsEditor.vue';
import AgmSignersPreview from '../AgmSignersPreview.vue';
import { useAgmStudio } from '../agmStudioContext';
import { buildAgmMemberRowLookupContext } from '../../agmMemberPersonLookup';

const { model, lookup } = useAgmStudio();
</script>

<template>
  <div class="agm-doc">
    <AgmDocHead />
    <div class="doc-title">ATTENDANCE LIST OF ANNUAL GENERAL MEETING</div>
    <AgmMeetingTable order="vdt" />
    <table class="cdd-tbl">
      <thead><tr><th>MEMBERS</th><th style="width:40%">SIGNATURES</th></tr></thead>
      <tbody>
        <tr v-if="model.memberType === 'multiple'">
          <td>
            <AgmRowsEditor :rows="model.members" add-label="+ Add member" placeholder="Member name" empty-note="Add at least two members."
              @lookup="(i: number) => lookup(buildAgmMemberRowLookupContext(i))" />
          </td>
          <td></td>
        </tr>
        <tr v-else-if="model.memberType === 'sole_corporate'">
          <td><CddVarField field-key="member_name" label="Sole Corporate Member" /><br />(represented by <CddVarField field-key="member_representative_name" label="Corporate Representative" />)</td>
          <td></td>
        </tr>
        <tr v-else>
          <td><CddVarField field-key="member_name" label="Sole Member" /></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <p class="doc-p">Certified by:</p>
    <AgmSignersPreview doc-kind="attendance" />
    <div class="doc-p">Chairman of the Meeting</div>
  </div>
</template>
